import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import type {
  TypeApiResponse,
  TypePostRequestGoodsUploadParams,
  TypePostRequestGoodsUploadResponse,
} from '~/types/receive.types';

type UploadParams = {
  ownerCode: string;
  params: TypePostRequestGoodsUploadParams;
};

/**
 * [입고요청등록] 입고 상품 엑셀 업로드 API
 */
const fetchPostRequestGoodsUpload = async ({ ownerCode, params }: UploadParams) => {
  const endpoint = '/api-inbound/v1/3pl/receiving';
  const { data } = await axiosInstance.post<TypeApiResponse<TypePostRequestGoodsUploadResponse>>(
    `${endpoint}/${ownerCode}/request/goods/upload`,
    params,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return data.data;
};

/**
 * [입고요청등록] 입고 상품 엑셀 업로드 Mutation Hook
 */
export const usePostRequestGoodsUploadMutation = () => {
  return useMutation({
    mutationFn: fetchPostRequestGoodsUpload,
    meta: { silent: true }, // 전역 에러 핸들러 비활성화 (사용처에서 개별 처리)
  });
};
